export const APP_UPDATE_EVENT = "automatari:app-update-required";

export type AppUpdateReason = "version-mismatch" | "stale-build-error";

const UNKNOWN_BUILD_IDS = new Set(["", "unknown", "not-set"]);
const STALE_BUILD_PATTERNS = [
  "an unexpected response was received from the server",
  "failed to find server action",
  "was not found on the server",
  "unrecognizedactionerror",
  "missing action",
] as const;

export function isStaleBuildError(error: unknown): boolean {
  if (error instanceof Error) {
    if (isStaleBuildErrorMessage(error.message)) {
      return true;
    }
    return error.name.toLowerCase().includes("unrecognizedaction");
  }
  return isStaleBuildErrorMessage(String(error ?? ""));
}

export function normalizeBuildId(value?: string | null): string | null {
  const normalized = value?.trim() ?? "";

  if (UNKNOWN_BUILD_IDS.has(normalized.toLowerCase())) {
    return null;
  }

  return normalized;
}

export function isStaleBuildErrorMessage(message: string): boolean {
  const normalized = message.trim().toLowerCase();

  return STALE_BUILD_PATTERNS.some((pattern) => normalized.includes(pattern));
}

export function dispatchAppUpdateRequired(reason: AppUpdateReason) {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<AppUpdateReason>(APP_UPDATE_EVENT, {
      detail: reason,
    })
  );
}
